export const environment = {
  production: true,
  homolog: false,
  development: false,
  baseUrl: 'https://backend.mottu.cloud/',
  baseUrlMonitor: 'https://beta-backend-monitor.mottu.cloud/',
  baseUrlMonitorTelemetria: 'https://monitor.mottu.cloud/',
  monitorFieldServicesApi: 'https://beta-monitor-field-service.mottu.cloud/',
  baseUrlMonitorServices: 'https://monitor-services.mottu.cloud/',
  baseUrlIotLock: 'https://iot-lock.mottu.cloud/',
  baseUrlTelemetries: 'https://gateway-telemetries-consumer.mottu.cloud/',
  baseUrlInventario: 'https://monitor-inventory.mottu.cloud/',
  signalRHub: 'https://monitorsuporterecolhimento.azurewebsites.net/api/',
  googleKey: 'AIzaSyDynpesuBknu-hxMFSFNWvvkbT-QzAHCHY',
  baseUrlAdminMottu: 'https://admin-v3.mottu.cloud/',
  baseUrlAlerta: 'https://monitor-alerts-service.mottu.cloud',
  baseUrlQuestioner: 'https://monitor-questioner.mottu.cloud/',
  pipefyApiUrl: 'https://api.pipefy.com/graphql',
  baseUrlMonitorIntegrator: 'https://monitor-integrator-manager.mottu.cloud/',
  baseUrlPagtoService: 'https://monitor-pagamento.mottu.cloud/',
  mottuMotos: 'https://motos.mottu.cloud/',
  baseUrlMaintenanceTriage: 'https://maintenance-triage.mottu.io/',
  baseUrlMottueBackend: 'https://mottue-backend.mottu.cloud/',
  baseUrlOcorrenciaService: 'https://monitor-ocorrencias.mottu.cloud/',
  baseUrlCheckinBases: 'https://checkin-bases-backend.mottu.cloud/',
  baseUrlApreensoesService: 'https://monitor-apreensoes.mottu.cloud/',
  branchManagementApi: 'https://branch-management.mottu.cloud/',
  baseUrlBackendMaintenance: 'https://maintenance-backend.mottu.cloud/',
  baseUrlMaintenance: 'https://maintenance.mottu.cloud/',
  baseUrlGatewayAlert: 'https://gateway-alerts.mottu.cloud/',
  baseUrlOperation: 'https://operation-backend.mottu.cloud/',
  baseUrlOperationBackendLegacy: 'https://operation-backend.mottu.cloud/',
  baseUrlPhotoBooth: 'https://maintenance-photo-booth.mottu.cloud/',
  baseUrlBranch: 'https://branch-management.mottu.cloud/',
  baseUrlMessageIntegratorUser: 'https://message-integration.mottu.cloud/',
  intercomUrl: 'https://api-iam.intercom.io',
  baseUrlCustomerSuccessV2: 'https://customer-success-v2.mottu.cloud',
  baseUrlOperationBackend: 'https://operacao.mottu.cloud',
  baseUrlCustomerSuccess: 'https://customer-success.mottu.cloud',
  baseUrlIcc: 'https://iot-integrated-circuit-card.mottu.cloud',
  muralAvisosLink: 'https://developer-71117.bubbleapps.io',
  baseUrlEmployeeManagement: 'https://employee-management.mottu.cloud/',
  baseUrlIOT: 'https://iot-rental-maintenance.mottu.cloud/',
  baseUrlBo: 'https://monitor-bo.mottu.cloud',
  baseUrlMonitorFlow: 'https://monitor-flow-api.mottu.cloud/',
  baseUrlPartnerManager: 'https://partner-manager-api.mottu.cloud',
  baseUrlLogisticsPartnerHub: 'https://logistics-partner-hub-backend.mottu.cloud',
  intercomId: 'j7qzgu9w',
  branchContextServiceDistribution: '02599899-aee4-4a8e-894a-84e3804aea34',
  mottuVeiculosBucket: 'mottu-veiculos',
  monitorDatabaseHelper: 'https://monitor-databases-helper.mottu.io/',
  testRiderApi: 'https://monitor-test-rider-api.mottu.cloud',
  environmentIdFlagsmith: 'fgPsduFmynXdxK3AtdFzTS',
  keycloak: {
    url: 'https://sso.mottu.cloud',
    realm: 'Internal',
    clientId: 'fleet-monitor-frontend-client',
  },
};
